export const SEARCH_DEALS = 'SEARCH_DEALS/SEARCH';
